// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a4586ab6","142":"a845e63f","330":"a1a71a09","361":"4803d91c","855":"5a61b6c0"}[chunkId] + ".chunk.js";
};